import { render } from "./CadastroTelasView.vue?vue&type=template&id=257bae92"
import script from "./CadastroTelasView.vue?vue&type=script&lang=js"
export * from "./CadastroTelasView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__